import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface Ilogs {
    file_name: string
    file_line: string
    message: string
    server_mode?: string
    server_id?: string
    server_type: string
    server_exchange?: string
    created_at: string
}

export interface ILogSummary {
    _id: string
    server_exchange: string
    server_type: string
    server_id: string
    major: {[key: string]: MajorLog}
    count: number
    day_time: number
    created_at: string
}

export interface MajorLog {
    message: string
    count: number
    level: string
}

export interface ILogsMonitor {
    [index: string]: MajorLogs
}

interface MajorLogs {
    daytime: number[]
    err_count: number[]
    warn_count: number[]
}

export const getLogSummaryList = async (size: number = 24): Promise<ApiRes<ILogsMonitor>> => {
    return await apiGet(API_URL, `admin/log_summary/dashboard?size=${size}`)
}

export const getLogSummary = async (server_id: string, created_at: string): Promise<ApiRes<ILogSummary>> => {
    return await apiGet(API_URL, `admin/log_summary?server_id=${server_id}&created_at=${created_at}`)
}
